
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","height":"48","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('color-brush-3')]),_c('path',{attrs:{"d":"M1.382,22.522a.552.552,0,0,1,.03-1.01c2.629-1.065,1.781-4.062,2.563-5.664a3.931,3.931,0,0,1,5.22-1.8C15.064,16.915,8.078,25.709,1.382,22.522Z","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}}),_c('path',{attrs:{"d":"M13.889,14.1,22.667,2.984a1.353,1.353,0,0,0-2.018-1.8L10.757,11.05","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5px"}})])
          )
        }
      }
    